<template>
    <section>
        <div class="page-wrap">
            <div class="container product">
                <div class="box-content">
                    <h2>Customize Your Order</h2>
                    <div>
                        <p>
                            Enter an inscription below to customize your brick.
                            Each line allows for {{ info.max_chars }} characters per line.
                            View our <a class="text-danger underline pointer"
                                v-on:click="showInscriptionGuidelines()"
                            >inscription policy</a> for more information.
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-md-7">
                            <div class="prod-container">
                                <img class="prod-img" v-bind:src="getProductImage(logo)"/>
                                <div class="prod-replica">
                                    <div class="prod-replica-table">
                                        <div class="prod-replica-table-td" v-bind:class="product.classes">
                                            <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <h3 v-html="product.description"></h3>
                            <h4>$&nbsp;{{ product.price }}</h4>
                            <hr/>
                            <h3>Brick Inscription:</h3>
                            <div class="brick-text-form">
                                <div v-for="n in product.max_lines" class="form-group row no-gutter">
                                    <div class="col-md-2">
                                        <label v-bind:for="'l-' + n">Line {{ n }}:</label>
                                    </div>
                                    <div class="col-md-10">
                                        <input class="form-control"
                                            v-bind:line-id="'l-' + n"
                                            v-on:keydown="withAnyKeyDown($event)"
                                            v-on:keyup="withAnyKeyUp($event)"
                                            v-on:input="withInput($event)"
                                            v-bind:id="'l-' + n"
                                            v-bind:value="lines[n-1]"
                                            v-bind:maxlength="product.max_characters"
                                            v-bind:size="product.max_characters"
                                        />
                                    </div>
                                </div>
                            </div>
                            <p>Need inspiration?
                                <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a>
                                for inscription examples.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>
                                <span class="text-danger">*</span>
                                All inscriptions will be subject to approval in accordance with the inscription guidelines.
                            </p>
                        </div>
                    </div>
                    <preferred-logo v-if="isMultiLogoAllowed"
                        ref="preflog"
                        v-bind:options="product.options || {}"
                        v-bind:logo="logo"
                        on-logo-change="onCartItemLogoChange"
                    ></preferred-logo>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="btn-wrap text-right">
                                <a class="btn btn-danger btn-md" v-on:click="saveInscription">Save</a>
                                <a class="btn btn-danger btn-md" v-on:click="cancelEditing">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script type="text/jsx">
    import Vue from 'vue'
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import store from '../../store'
    import { mapState, mapGetters } from 'vuex'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    import InscriptionHandlingMixin from '../mixin/inscription-handling.vue'
    import ProductHandlingMixin from '../mixin/product-handling.vue'
    import PreferredLogo from '../elements/preferred-logo.vue'
    export default {
        name: 'edit-inscription',
        mixins: [
            CampaignConfigurationMixin,
            InscriptionEditMixin,
            InscriptionHandlingMixin,
            ProductHandlingMixin
        ],
        components: {
            'preferred-logo': PreferredLogo
        },
        props: {
            isLowerCaseAllowed: { // to override default value in InscriptionEditMixin
                type: String,
                default: () => 'no'
            },
            info: {
                type: Object, // can be modified by child component
                required: false,
                default: function () {
                    return {
                        max_chars: 16 // minimal known value as default
                    };
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            let cartId = to.params.id;
            if (cartId in store.getters.cart) {
                let item = store.getters.cart[cartId];
                let isGc = 'gc' in item ? item.gc : false;
                if (isGc) {
                    next({name: 'Cart'})
                } else {
                    next();
                }
            } else {
                next({name: 'Cart'});
            }
        },
        computed: {
            ...mapState([
                'campaign'
            ]),
            ...mapGetters([
                'products', 'cart'
            ]),
            product: function () {
                var cartId = this.$route.params.id;
                var itemId = this.cart[cartId].item_id;
                if (itemId in this.products) {
                    return this.products[itemId];
                }
                return {};
            },
            lines: function () {
                return this.cart[this.$route.params.id].lines;
            },
            location: {
                get: function () {
                    var location = '';
                    var options = this.cart[this.$route.params.id].options || {};
                    if ('location' in options) {
                        location = options.location;
                    }
                    return location;
                },
                set: function (newValue) {
                    // it is not allowed to be modified directly
                    console.log('attempt to set location to new value:', newValue);
                }
            },
            logo: {
                get: function () {
                    var logo = '';
                    var options = this.cart[this.$route.params.id].options || {};
                    if ('logo' in options) {
                        logo = options.logo;
                    }
                    return logo;
                },
                set: function (newValue) {
                    // it is not allowed to be modified directly
                    console.log('attempt to set logo to new value:', newValue);
                }
            },
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            },
            logosList: function () {
                var res = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in this.product && this.product.options) {
                        if ("logo" in this.product.options && this.product.options.logo) {
                            res = this.product.options.logo;
                        }
                    }
                }
                return res;
            }
        },
        created: function () {
            Event.$on('onCartItemLocationChange', this.onLocationChange);
            Event.$on('onCartItemLogoChange', this.onLogoChange);
        },
        beforeDestroy: function () {
            Event.$off('onCartItemLocationChange', this.onLocationChange);
            Event.$off('onCartItemLogoChange', this.onLogoChange);
        },
        methods: {
            showInscriptionGuidelines: function () {
                Event.$emit('inscriptionGuidelinesPopup');
            },
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            },
            updateInscription: function (data) {
                if ('id' in data && 'text' in data) {
                    var parts = ('' + data.id).split('-', 2); // eq. l-1
                    if (parts.length == 2) {
                        var lineIndex = +parts[1] - 1;
                        Vue.set(this.lines, lineIndex, data.text);
                    }
                }
            },
            onLocationChange: function (newLocation) {
                if (newLocation.length > 0) {
                    this.$store.commit('updatePreferredLocation', {
                        cartId: +this.$route.params.id,
                        location: newLocation
                    });
                }
            },
            onLogoChange: function (newLogo) {
                if (newLogo.length > 0) {
                    this.$store.commit('updatePreferredLogo', {
                        cartId: +this.$route.params.id,
                        logo: newLogo
                    });
                }
            },
            saveInscription: function () {
                this.validateProductProperties().then(() => {
                    this.$store.commit('updateInscription', {
                        cartId: +this.$route.params.id,
                        lines: this.lines
                    });
                    this.$router.push({ path: '/cart'});
                }).catch(() => {
                    console.log('Editing Inscription failed due to validation errors!');
                });
            },
            cancelEditing: function () {
                this.$router.push({ path: '/cart'});
            },
            getProductImage: function (logoId) {
                var res = '';
                if (logoId in this.logosList) {
                    res = this.baseImagePath + this.logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + this.product.item_image_blank;
                return res;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// EditInscription.vue?71c5003f